module.exports = __webpack_public_path__ + "img/dfs_logo.b005b93a.png";